/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPuzzle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.8 3.005a4.002 4.002 0 0 0-3.63 2.84L8.125 6H4v16h16v-6h-1a2 2 0 1 1 0-4h1V6h-4.127l-.042-.155A4.002 4.002 0 0 0 12 3zM12 5a2 2 0 0 1 2 2v1h4v2.126l-.155.043A4.002 4.002 0 0 0 15 14l.005.2a4.002 4.002 0 0 0 2.84 3.63l.155.043V20H6V8h4V7a2 2 0 0 1 2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPuzzle as Puzzle };
